export default __webpack_public_path__ + "static/media/himshers.5703b62d.svg";